export const CATEGORIES = {
  rules: {
    icon: 'document-edit',
  },
  'advertising-networks': {
    icon: 'gramophone',
  },
  finance: {
    icon: 'money',
  },
  'for-legal-entities': {
    icon: 'user',
  },
  marking: {
    icon: 'tag',
  },
  'agency-account': {
    icon: 'profile',
  },
}
